import { ActivityEntity } from '../entities/activity-entity';

export default class State {
  loaded = false;

  items: Array<ActivityEntity> = [];
}
